import config from 'config';
import { UserRole } from 'generated/globalTypes';
import { ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import useAuth from '../hooks/useAuth';
import Login from '../pages/auth/Login';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    if (pathname !== '/') return <Navigate to={'/'} />;
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} />;
  }

  if (pathname === '/' && user) {
    if ([...config.allAdmins, UserRole.MANAGER].includes(user.role)) {
      return <Navigate to={'/dashboard'} />;
    }

    if ([UserRole.OPERATOR, UserRole.DOCTOR].includes(user.role)) {
      return <Navigate to={'/participant-examinations'} />;
    }
  }

  return <>{children}</>;
}
